import { gql } from 'react-apollo';
import { full } from "../../../../graphql/fragments/faqAnswer";

export const createFaqAnswer = gql`
  mutation createFaqAnswer($input: CreateFaqAnswerInput!) {
    createFaqAnswer(input: $input) {
      faqAnswer: faq_answer {
        ...allFaqAnswersFields
      }
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/mutations/createFaqAnswer.js